import * as React from "react";
const SvgHome20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m9 .75 9 6.75V18h-7.5v-4.5a1.5 1.5 0 0 0-3 0V18H0V7.5L9 .75ZM2 8.5V16h3.5v-2.5a3.5 3.5 0 1 1 7 0V16H16V8.5L9 3.25 2 8.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgHome20Px;
